export default __webpack_public_path__ + "static/Tshirt-3c8a0b683dc8fec6742daf7c4590739b.svg";